module.exports = __webpack_public_path__ + "img/exe_pdf_3.fa465b18.png";